export default __webpack_public_path__ + "static/media/Exercise.c8832090.svg";